import { ENDPOINTS } from 'utils/api/callApi'
import { generateApiActionTypes } from './generateActionTypes'

export const AUTO_CONFIRM_ACTION_TYPES = generateApiActionTypes('AUTO_CONFIRM')

export const autoConfirmStop = (
  id,
  autoConfirmToken,
  startAtTime,
  endAtTime,
  actionTypes = AUTO_CONFIRM_ACTION_TYPES
) => {
  if (!autoConfirmToken) return {}
  const requestData = {
    endpoint: ENDPOINTS.shipmentStops,
    id,
    group: 'auto_confirm',
    method: 'POST',
    body: {
      auto_confirm_token: autoConfirmToken,
      start_at_time: startAtTime,
      end_at_time: endAtTime,
    },
  }
  return {
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(actionTypes),
    },
  }
}
